import api from '@/services/api';

const UserQuery = {
  getUserList: () => {
    return api.get('get_user_list/');
  },
  getCompanyUserList: () => {
    return api.get('get_company_user_list/');
  },
  getUserDetail: () => {
    return api.get('get_user_detail/');
  }
};

export default UserQuery;



// WEBPACK FOOTER //
// ./src/api/account/user/query.js